<template>
	<div class="modal fade" id="lb-get-product-mail" tabindex="-1">
		<div class="modal-dialog modal-sm" role="document">
			<div class="modal-content">
				<form id="form-instock-mail">
					<div class="modal-header">
						<h4 class="modal-title">貨到通知</h4>
						<a class="close" href="#" data-dismiss="modal" aria-label="Close"><i class="icon-remove-x"></i></a>
					</div>
					<div class="modal-body">
						<input v-model="usermail" type="email" name="mail" placeholder="輸入E-mail" class="form-control" required />
						<p class="mt-1">*提醒您，此貨到通知不提供商品保留功能</p>
					</div>
					<div class="modal-footer">
						<div class="w-100">
							<button @click.prevent="getNotice" type="button" class="btn btn-primary w-100 d-block">Submit</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ["custommarketid"],
	data: function () {
		return {
			usermail: "",
		};
	},
	methods: {
		getNotice: function () {
			var _this = this;
			var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
			if (this.usermail.length !== 0 && regex.test(this.usermail)) {
				$.ajax({
					type: "POST",
					url: API_URL.IN_STOCK_EMAIL,
					dataType: "json",
					data: { CustomMarketID: _this.custommarketid, Email: _this.usermail },
					xhrFields: {
						withCredentials: true,
					},
					error: function () {
						console.log("error");
					},
					success: function (res) {
						if (res.Code === 200) {
							AlertDialog.alert("貨到通知索取成功!謝謝您~", function () {
								$("#lb-get-product-mail").modal("hide");
							});
						} else {
							$("#lb-get-product-mail").modal("hide");
						}
					},
				});
			} else {
				AlertDialog.alert("請輸入有效Email");
			}
		},
	},
};
</script>
